// ═══════════════════════════════════════════════════════════════
// FULFILLMENT PROGRESS BAR
// Path: src/components/shows/FulfillmentProgressBar.jsx
//
// Compact N/total bar + status badge.
// Used in SponsorshipCard header and DonorDetailView.
//
// Props:
//   fulfilled  — number of fulfilled benefits
//   total      — total benefit count
//   compact    — boolean (smaller variant for inline use)
//
// Blueprint: CMM_Show_Sponsorship_Blueprint_v1_1.md — Phase 5
// ═══════════════════════════════════════════════════════════════

import React from "react";
import { useApp } from "../../context/AppContext";
import { FONT_SIZES, FONT_FAMILY } from "../../constants/appConfig";

export const FulfillmentProgressBar = ({
  fulfilled = 0,
  total = 0,
  compact = false,
}) => {
  const { palette } = useApp();

  const isComplete = total > 0 && fulfilled === total;
  const pct = total > 0 ? Math.round((fulfilled / total) * 100) : 0;

  const barHeight = compact ? 6 : 8;
  const barColor = isComplete ? "#16a34a" : "#f59e0b";
  const badgeBg = isComplete ? "#dcfce7" : "#fef3c7";
  const badgeColor = isComplete ? "#16a34a" : "#92400e";
  const badgeLabel = isComplete ? "Complete" : "Pending";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: compact ? 6 : 8,
      }}
    >
      {/* Progress bar */}
      <div
        style={{
          flex: 1,
          height: barHeight,
          background: `${palette.text3}20`,
          borderRadius: barHeight / 2,
          overflow: "hidden",
          minWidth: compact ? 40 : 60,
        }}
      >
        <div
          style={{
            width: `${pct}%`,
            height: "100%",
            background: barColor,
            borderRadius: barHeight / 2,
            transition: "width 0.3s ease",
          }}
        />
      </div>

      {/* Count label */}
      <span
        style={{
          fontSize: compact ? "0.65rem" : FONT_SIZES.xs,
          fontWeight: 600,
          color: palette.text2,
          fontFamily: FONT_FAMILY,
          whiteSpace: "nowrap",
          flexShrink: 0,
        }}
      >
        {fulfilled} / {total}
      </span>

      {/* Status badge */}
      {!compact && (
        <span
          style={{
            fontSize: "0.6rem",
            fontWeight: 700,
            padding: "2px 8px",
            borderRadius: 10,
            background: badgeBg,
            color: badgeColor,
            fontFamily: FONT_FAMILY,
            flexShrink: 0,
          }}
        >
          {badgeLabel}
        </span>
      )}
    </div>
  );
};
